var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0385 6.27354V6.34615H12.6924V0H12.765L19.0385 6.27354Z",
    fill: "#919EAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.03846V0H0V22H19.0385V8.03846H11ZM10.859 19.6731H2.96154V17.9808H10.859V19.6731ZM14.8077 15.8654H2.96154V14.1731H14.8077V15.8654ZM14.8077 12.0577H2.96154V10.3654H14.8077V12.0577Z",
    fill: "#919EAB"
  })));
};

export default __webpack_public_path__ + "static/media/FileIcon.21d2fa67.svg";
export { SvgComponent as ReactComponent };